import { useMutation, useQuery } from 'react-query';
import modelApi from '../apis/models';

const { fetchMaleModelList } = modelApi;
export const useGetMaleModelsData = (
  remark,
  isAuthenticated,
  pageNum,
  pageSize,
  visibility,
  gender,
  currentProduct,
  searchText,
  category,
  onSuccess,
  onError
) =>
  useQuery(
    [
      '' + remark,
      isAuthenticated,
      pageNum,
      pageSize,
      visibility,
      gender,
      currentProduct,
      searchText,
      category,
    ],
    () =>
      fetchMaleModelList(
        isAuthenticated,
        pageNum,
        pageSize,
        visibility,
        gender,
        currentProduct,
        searchText,
        category
      ),
    {
      onSuccess,
      onError,
    }
  );
